import React from 'react'
import SVG from 'react-svg-inline'
import ReactPlayer from 'react-player'
import ImageZoom from 'react-medium-image-zoom'

const Cookies = () =>
  <div>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          “[…] Other European countries already have convenient peer-to-peer payment apps, but Cookies is a well-executed product that should work quite well in Germany.”
          <span>— Techcrunch</span>
        </blockquote>
      </div>
    </section>
    <section className="container">
    <div className="fullwidth-video-wrapper">
      {/* <video src="https://www.youtube.com/watch?v=-1sX-giVzeE" loop muted autoPlay className="fullwidth-video" /> */}
      <ReactPlayer
        url="https://www.youtube.com/embed/A20WhFPjELM"
        className="video-player"
        width="100%"
        height="100%"
        playing={false}
        playbackRate={1}
        loop={false}
        // volume={0}
        controls={true}
        // youtubeConfig={{ attributes: { preload: true } }}
        // TODO Add custom posters for videos (to be also used as fallback images) 👇 This is supposed to work: https://github.com/CookPete/react-player/issues/62
        fileConfig={{ attributes: { poster: 'https://placehold.it/100x100/' } }}
      />
    </div>
    </section>
    <section className="container full">
      <div className="col-12-of-12">
        <img
          src={require('img/cookies/iphone-hand.jpg')}
          alt="Cookies Feature"
        />
      </div>
    </section>
    {/* <section className="container full">
      <div className="col-12-of-12">
        <img
          src={require('img/cookies/cookies-blue-row.jpg')}
          alt="Cookies Feature"
        />
      </div>
    </section> */}
    <section className="container full">
      <div className="col-12-of-12">
        <img
          src={require('img/cookies/grid-of-phones.jpg')}
          alt="Cookies Feature"
        />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          This fintech startup wanted to tackle the P2P money transfer problem providing a friendly, playful & rememberable user experience. The technical processes behind it were actually groundbreaking in the financial sector, but the design had to align with the main value of "making banking stuff easier & approchable". 💸 😜
        </blockquote>
      </div>
    </section>

    {/* <section className="container m-tb-m">
      <div className="col-1-of-1">
        <SVG svg={require('img/cookies/camera-options.svg')} width="100%" />
      </div>
    </section> */}
    <section className="container">
      <div>
        <ImageZoom
          image={{
            src: require('img/cookies/iphones-1.png'),
            alt: 'Cookies',
          }}
        />
      </div>
    </section>
    <section className="container">
      <div>
        <ImageZoom
          image={{
            src: require('img/cookies/iphones-2.png'),
            alt: 'Cookies',
          }}
        />
      </div>
    </section>
    <section className="container">
      <div>
        <ImageZoom
          image={{
            src: require('img/cookies/iphones-3.png'),
            alt: 'Cookies',
          }}
        />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
            Being able to work from scratch to ensure that everything was inline was a pleasure, I must say. The project had had a few different verticals but the main ones were Branding, Website, Webapp, iOS App & Android App.
        </blockquote>
      </div>
    </section>
    <section className="container full">
          <div className="col-12-of-12">
            <img
              src={require('img/cookies/cover-logo.jpg')}
              alt="Cookies Feature"
            />
          </div>
    </section>
  </div>

export default Cookies



// WEBPACK FOOTER //
// src/javascripts/clients/Cookies.js